<template>
  <div>
    <v-btn color="success">Success</v-btn>
    <v-btn color="error">Error</v-btn>
    <v-btn color="warning">Warning</v-btn>
    <v-btn color="info">Info</v-btn>
    <v-btn color="primary">Primary</v-btn>
  </div>
</template>
<template>
  <div class="dashboard-page">
    <v-container fluid>
      <v-layout align-content-start align-start justify-start>
        <v-flex md3 class="conversations-container">
          <v-tabs centered color="secondary" icons-and-text v-model="selectedList" grow>
            <v-tabs-slider color="primary"></v-tabs-slider>
            <v-tab href="#tab-available">
              {{$t("Available Dreams")}} ({{conversationsCount}})
              <v-icon>notifications_active</v-icon>
            </v-tab>
            <v-tab href="#tab-history">
              {{$t("History Logs")}} ({{historyConversationsCount}})
              <v-icon>history</v-icon>
            </v-tab>
            <v-tab-item id="tab-available">
              <div v-bar>
                <div>
                  <v-list>
                    <template v-for="(item, index) in conversations">
                      <v-list-tile @click="view(item)" :key="'conversation-'+item.id+'-'+index">
                        <v-tooltip left>
                          <v-list-tile-avatar slot="activator">
                            <v-chip
                              :color="item.status === 'Pending'?'warning':(item.status === 'Rejected'?'red':'success')"
                              text-color="white"
                            >{{item.status.substring(0,1)}}</v-chip>
                          </v-list-tile-avatar>
                          <span>{{$t(item.status)}}</span>
                        </v-tooltip>
                        <v-list-tile-content>
                          <v-list-tile-title v-text="item.question.message"></v-list-tile-title>
                        </v-list-tile-content>
                        <v-list-tile-action>
                          <v-btn icon ripple>
                            <v-icon
                              color="grey lighten-1"
                              v-if="conversation && item.id === conversation.id"
                            >arrow_back</v-icon>
                          </v-btn>
                        </v-list-tile-action>
                      </v-list-tile>
                      <v-divider v-if="index + 1 < conversations.length" :key="index"></v-divider>
                    </template>
                  </v-list>
                  <v-btn
                    color="default"
                    dark
                    block
                    ripple
                    style="margin-bottom:auto;"
                    v-if="conversations.length < conversationsCount"
                    @click="loadData(false,parseInt((conversationsCount - (conversationsCount - conversations.length))/pageSize) + 1,pageSize)"
                  >
                    <v-icon color="grey lighten-1">arrow_downward</v-icon>
                    {{$t("Load More")}}
                  </v-btn>
                </div>
              </div>
            </v-tab-item>
            <v-tab-item id="tab-history">
              <div v-bar>
                <div>
                  <v-list>
                    <template v-for="(item, index) in historyConversations">
                      <v-list-tile
                        @click="view(item)"
                        :key="'history-conversation-'+item.id+'-'+index"
                      >
                        <v-tooltip left>
                          <v-list-tile-avatar slot="activator">
                            <v-chip
                              :color="item.status === 'Pending'?'warning':(item.status === 'Rejected'?'red':'success')"
                              text-color="white"
                              :title="$t(item.status)"
                            >{{item.status.substring(0,1)}}</v-chip>
                          </v-list-tile-avatar>
                          <span>{{$t(item.status)}}</span>
                        </v-tooltip>
                        <v-list-tile-content>
                          <v-list-tile-title v-text="item.question.message"></v-list-tile-title>
                        </v-list-tile-content>
                        <v-list-tile-action>
                          <v-btn icon ripple>
                            <v-icon
                              color="grey lighten-1"
                              v-if="conversation && item.id === conversation.id"
                            >arrow_back</v-icon>
                          </v-btn>
                        </v-list-tile-action>
                      </v-list-tile>
                      <v-divider v-if="index + 1 < historyConversations.length" :key="index"></v-divider>
                    </template>
                  </v-list>
                  <v-btn
                    color="default"
                    dark
                    block
                    ripple
                    style="margin-bottom:auto;"
                    v-if="historyConversations.length < historyConversationsCount"
                    @click="loadData(true,parseInt((historyConversationsCount - (historyConversationsCount - historyConversations.length))/pageSize) + 1,pageSize)"
                  >
                    <v-icon color="grey lighten-1">arrow_downward</v-icon>
                    {{$t("Load More")}}
                  </v-btn>
                </div>
              </div>
            </v-tab-item>
          </v-tabs>
        </v-flex>
        <v-flex md5 class="dream-view-container">
          <div v-bar>
            <div>
              <div v-if="conversation">
                <v-card color="blue-grey darken-4" class="white--text">
                  <v-toolbar color="blue-grey darken-4" dark flat>
                    <v-toolbar-title>#{{conversation.id}}</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <star-rating
                      read-only
                      v-model="conversation.rank"
                      v-if="conversation.status === 'Closed' && conversation.rank"
                      rtl
                      :star-size="20"
                      active-color="#f8bb58"
                      inactive-color="#455A64"
                      :show-rating="false"
                      rounded-corners
                      :padding="8"
                    ></star-rating>
                    <v-spacer></v-spacer>
                    {{$t(conversation.status)}}
                  </v-toolbar>
                  <v-card-text>
                    <timeago
                      :datetime="conversation.question.date_time"
                      :auto-update="60"
                      class="blue-grey--text text--lighten-1"
                    ></timeago>
                    <p>{{conversation.question.message}}</p>
                  </v-card-text>
                  <v-card-text v-if="conversation.response">
                    <timeago
                      :datetime="conversation.response.date_time"
                      :auto-update="60"
                      class="blue-grey--text text--lighten-1"
                    ></timeago>
                    <p class="success--text">{{conversation.response.message}}</p>
                  </v-card-text>
                  <v-card-text v-if="conversation.warning">
                    <timeago
                      :datetime="conversation.warning.date_time"
                      :auto-update="60"
                      class="blue-grey--text text--lighten-1"
                    ></timeago>
                    <p class="red--text">{{conversation.warning.message}}</p>
                  </v-card-text>
                  <div v-if="conversation.client">
                    <v-chip color="orange" label outline v-if="conversation.client.gender">{{$t(conversation.client.gender)}}</v-chip>
                    <v-chip color="orange" label outline
                      v-if="conversation.client.maritalStatus"
                    >{{$t(conversation.client.maritalStatus)}}</v-chip>
                    <v-chip color="orange" label outline v-if="conversation.client.dob">{{conversation.client.dob}} {{$t('Year')}}</v-chip>
                    <v-chip color="orange" label outline v-if="conversation.client.profession">{{conversation.client.profession}}</v-chip>
                    <v-chip color="orange" label outline v-if="conversation.client.childrenCount">{{conversation.client.childrenCount}} {{$t('Children')}}</v-chip>
                  </div>
                  <v-card-actions v-if="conversation.status === 'Pending'">
                    <v-btn
                      flat
                      dark
                      color="red"
                      @click="writeNote"
                      v-if="!enableNote"
                    >{{$t("Reject")}}</v-btn>
                    <v-btn
                      flat
                      dark
                      color="success"
                      @click="accept"
                      v-if="!enableNote"
                    >{{$t("Accept")}}</v-btn>
                  </v-card-actions>
                  <v-slide-y-transition>
                    <v-card-text v-show="conversation.status === 'Pending' && enableNote">
                      <v-textarea
                        dark
                        flat
                        no-resize
                        box
                        v-model="note"
                        :placeholder="$t('Why you reject this dream?')"
                      ></v-textarea>
                      <v-btn flat dark color="yellow" @click="cancelRejection">{{$t("Cancel")}}</v-btn>
                      <v-btn flat dark color="blue" @click="reject">{{$t("Continue")}}</v-btn>
                    </v-card-text>
                  </v-slide-y-transition>
                  <v-btn
                    color="default"
                    dark
                    block
                    ripple
                    style="margin-bottom:auto;"
                    v-if="conversation"
                    @click="searchConversationQuestion()"
                  >
                    <v-icon color="grey lighten-1">search</v-icon>
                    {{$t("Search")}}
                  </v-btn>
                </v-card>
                <v-card v-if="conversation.status === 'Accepted'">
                  <v-card-title primary-title>
                    <div>
                      <div class="headline">
                        <bdi>{{$t("The Explanation")}}</bdi>
                      </div>
                    </div>
                  </v-card-title>
                  <v-card-text>
                    <v-textarea
                      flat
                      no-resize
                      box
                      v-model="response"
                      :placeholder="$t('Write your explanation Here')"
                    ></v-textarea>
                    <v-btn dark color="blue" @click="resolve">{{$t("Send")}}</v-btn>
                  </v-card-text>
                </v-card>
              </div>
            </div>
          </div>
        </v-flex>
        <v-flex md4 class="search-helper-container">
          <v-card>
            <v-card-text class="explanations">
              <div class="text-xs-center" v-if="explanationsCount">
                <v-chip color="primary" label outline>{{explanationsCount}}</v-chip>
                <v-chip
                  color="green"
                  label outline
                  v-for="(explanationTag, index) in explanationsTags"
                  v-bind:key="'explanation-tag-'+index"
                >{{explanationTag.name}}</v-chip>
              </div>
              <v-card
                v-for="(explanation, index) in explanations"
                v-bind:key="'explanation-'+explanation.id+'-'+index"
              >
                <v-card-title>
                  <div>
                    <span class="grey--text">#{{index+1}}</span>
                    <span class="primary--text">{{$t(explanation.resultLabel)}}</span>
                  </div>
                </v-card-title>
                <v-treeview :items="bookTree(explanation)" open-all class="book-tree"></v-treeview>
                <v-card-text>
                  <p class="primary--text font-weight-bold headline">{{explanation.text}}</p>
                </v-card-text>
              </v-card>
              <v-btn
                color="default"
                dark
                block
                ripple
                style="margin-bottom:auto;"
                v-if="explanations.length < explanationsCount"
                @click="searchIntoBooks(parseInt((explanationsCount - (explanationsCount - explanations.length))/pageSize) + 1,pageSize)"
              >
                <v-icon color="grey lighten-1">arrow_downward</v-icon>
                {{$t("Load More")}}
              </v-btn>
            </v-card-text>
            <v-card-text class="search-input">
              <v-textarea
                flat
                no-resize
                box
                v-model="searchText"
                :placeholder="$t('Search Text')"
                :append-outer-icon="'send'"
                @click:append-outer="searchIntoBooks(1, pageSize)"
                clearable
              ></v-textarea>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>
<script>
export default {
  data() {
    return {
      pageSize: 25,
      conversations: [],
      conversationsCount: 0,
      historyConversations: [],
      historyConversationsCount: 0,
      conversation: null,
      enableNote: false,
      note: "",
      response: "",
      selectedList: "tab-available",
      searchText: "",
      explanations: [],
      explanationsCount: 0,
      explanationsTags: []
    };
  },
  created() {
    this.loadData(false, 1, this.pageSize);
    this.loadData(true, 1, this.pageSize);
  },
  notifications: {
    acceptedMessage: {
      message: "Accepted Successfully",
      type: "success"
    },
    rejectedMessage: {
      message: "Rejected Successfully",
      type: "success"
    },
    resolvedMessage: {
      message: "Resolved Successfully",
      type: "success"
    },
    errorMessage: {
      message: "Error Occurred",
      type: "error"
    }
  },
  methods: {
    loadData(history = false, page = 1, pageSize = 25) {
      this.$api.conversations(history, page, pageSize).then(response => {
        if (!response.error) {
          if (history) {
            this.historyConversations = [
              ...this.historyConversations,
              ...response.list.conversations
            ];
            this.historyConversationsCount = response.list.totalCount;
          } else {
            this.conversations = [
              ...this.conversations,
              ...response.list.conversations
            ];
            this.conversationsCount = response.list.totalCount;
          }
        }
      });
    },
    view(conversation) {
      this.enableNote = false;
      this.note = "";
      this.response = "";
      this.conversation = conversation;
    },
    writeNote() {
      this.enableNote = true;
      this.note = "";
    },
    cancelRejection() {
      this.enableNote = false;
      this.note = "";
    },
    accept() {
      if (this.conversation && this.conversation.status === "Pending") {
        this.$api.acceptConversation(this.conversation.id).then(response => {
          if (!response.error) {
            if (response.list.accepted) {
              this.conversation = response.list.conversation;
              this.conversations = this.conversations.map(conversation => {
                if (conversation.id === this.conversation.id) {
                  return this.conversation;
                }
                return conversation;
              });
            } else {
              this.errorMessage({ message: this.$t("Error Occurred") });
            }
          } else {
            this.errorMessage({ message: response.message });
          }
        });
      }
    },
    reject() {
      if (
        this.conversation &&
        this.conversation.status === "Pending" &&
        this.note.trim()
      ) {
        this.$api
          .rejectConversation(this.conversation.id, this.note)
          .then(response => {
            if (!response.error) {
              if (response.list.rejected) {
                this.conversation = response.list.conversation;
                this.conversations = this.conversations.filter(conversation => {
                  return conversation.id !== this.conversation.id;
                });
                this.conversationsCount--;
                this.historyConversations.push(this.conversation);
                this.historyConversationsCount++;
              } else {
                this.errorMessage({ message: this.$t("Error Occurred") });
              }
            } else {
              this.errorMessage({ message: response.message });
            }
          });
      }
    },
    resolve() {
      if (
        this.conversation &&
        this.conversation.status === "Accepted" &&
        this.response.trim()
      ) {
        this.$api
          .resolveConversation(this.conversation.id, this.response)
          .then(response => {
            if (!response.error) {
              if (response.list.resolved) {
                this.conversation = response.list.conversation;
                this.conversations = this.conversations.filter(conversation => {
                  return conversation.id !== this.conversation.id;
                });
                this.conversationsCount--;
                this.historyConversations.push(this.conversation);
                this.historyConversationsCount++;
              } else {
                this.errorMessage({ message: this.$t("Error Occurred") });
              }
            } else {
              this.errorMessage({ message: response.message });
            }
          });
      }
    },
    searchIntoBooks(page = 1, pageSize = 25) {
      if (page === 1) {
        this.explanations = [];
        this.explanationsTags = [];
        this.explanationsCount = 0;
      }
      this.$api.searchBooks(this.searchText, page, pageSize).then(response => {
        this.explanations = [
          ...this.explanations,
          ...response.list.explanations
        ];
        if (page === 1) {
          this.explanationsTags = response.list.tags;
          this.explanationsCount = response.list.count;
          console.log(response.list.count, " : ", response.list.tags);
        }
      });
    },
    bookTree(explanation) {
      let items = [];
      items.push({
        id: explanation.book.id,
        name: explanation.book.name,
        children: [
          {
            id: explanation.chapter.id,
            name: explanation.chapter.name,
            children: [
              {
                id: explanation.section.id,
                name: explanation.section.name
              }
            ]
          }
        ]
      });
      return items;
    },
    searchConversationQuestion() {
      this.searchText = this.conversation.question.message;
      this.searchIntoBooks(1, this.pageSize);
    }
  }
};
</script>
<style lang="scss">
.dashboard-page {
  display: flex;
  height: 100%;
  overflow: hidden;
  > .container {
    display: flex;
    height: 100%;
    min-height: 100%;
    padding: 0;
    > .layout {
      > .flex {
        height: calc(100vh - 64px);
        min-height: calc(100vh - 64px);
        &.conversations-container {
          overflow-y: auto;
          overflow-x: hidden;
        }
        &.dream-view-container {
          border-left: 1px solid #ccc;
          border-right: 1px solid #ccc;
          overflow-y: auto;
          overflow-x: hidden;
        }
        &.search-helper-container {
          background: #e6e6e6;
          .v-card {
            height: 100%;
            min-height: 100%;
            display: flex;
            flex-direction: column;
            .explanations {
              flex: auto;
              background: #e6e6e6;
              overflow-y: auto;
              overflow-x: hidden;
            }
            .search-input {
              height: 100px;
              min-height: 100px;
              border-top: 1px solid #ccc;
              padding: 0;
              background: #e6e6e6;
              position: relative;
              .v-input__slot {
                border-radius: 0;
                background: #e6e6e6;
                margin-bottom: 0;
                &:before,
                &:after {
                  display: none;
                }
                .v-text-field__slot {
                }
              }
              textarea {
                height: 98px;
                margin-top: 0;
                direction: rtl;
              }
              .v-input__append-inner {
                position: absolute;
                top: -7px;
                left: -32px;
              }
              .v-input__icon--append-outer {
                .v-icon {
                  transform: scaleX(-1);
                }
              }
              .v-input__append-outer {
                margin-bottom: 7px;
                margin-top: auto;
                margin-left: 6px;
                margin-right: 10px;
                .v-input__icon {
                  .v-icon {
                    &:hover,
                    &:focus {
                      color: #5379fb;
                    }
                  }
                }
              }
              .v-input--is-focused {
                .v-input__slot {
                  background: #e6e6e6;
                }
              }
              .v-text-field__details {
                display: none;
              }
            }
          }
          .book-tree {
            overflow: hidden;
            .v-treeview-node__root {
              height: auto;
              min-height: 34px;
              overflow: hide;
              .v-treeview-node__content {
                width: 50%;
                min-width: 50%;
                height: auto;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                .v-treeview-node__label {
                  display: block;
                  white-space: nowrap;
                  overflow: hidden;
                  text-overflow: ellipsis;
                }
              }
            }
          }
        }
        .v-card {
          border-radius: 0;
        }
      }
    }
  }
}
</style>


